export default __webpack_public_path__ + "static/expo5-cb51426236925e7aa7b98aa4f982d383.jpg";